module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-container"
  }, [_c('div', {
    staticClass: "title-btn"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.value ? 'selection-btn isActive' : 'selection-btn',
    on: {
      "click": function($event) {
        return _vm.$emit('input', !_vm.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05cba0f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectionBtn.vue
// module id = 428
// module chunks = 2 8 10 17